'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.prepareTopics = exports.combineArrays = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _requestIdleCallback = require('request-idle-callback');

var _requestIdleCallback2 = _interopRequireDefault(_requestIdleCallback);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// [a, b] + [c, d, e] = [ a, c, b, d, e ]
var combineArrays = exports.combineArrays = function combineArrays(first, second) {
    var result = [];
    while (first.length > 0 || second.length > 0) {
        if (first.length > 0) {
            result.push(first.shift());
        }
        if (second.length > 0) {
            result.push(second.shift());
        }
    }

    return result;
};

// in order to subscribe for prices in both columns in parallel.
var prepareTopics = exports.prepareTopics = function prepareTopics(topics) {
    var preparedTopics = [];
    if ((0, _jquery2.default)(document).width() < 768) {
        preparedTopics = Array.from(topics);
    } else {
        var center = topics.findIndex(function (topic) {
            return topic.indexOf && topic.indexOf('WIN/M') > -1;
        });
        preparedTopics = combineArrays(topics.slice(0, center), topics.slice(center));
    }

    return preparedTopics;
};

var Subscriber = function () {
    function Subscriber(session) {
        var chunkSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;

        _classCallCheck(this, Subscriber);

        this.taskList = [];
        this.isActive = false;
        this.session = session;
        this.currentTaskId = 0;
        this.chunkSize = chunkSize;
        this.runTask = this.runTask.bind(this);
    }

    _createClass(Subscriber, [{
        key: 'run',
        value: function run() {
            this.isActive = true;
        }
    }, {
        key: 'stop',
        value: function stop() {
            this.isActive = false;
        }
    }, {
        key: 'addTask',
        value: function addTask(taskHandler, taskData) {
            this.taskList.push({
                handler: taskHandler,
                data: taskData
            });

            if (!this.currentTaskId) {
                this.currentTaskId = _requestIdleCallback2.default.requestIdleCallback(this.runTask, { timeout: 1000 });
            }
        }
    }, {
        key: 'runTask',
        value: function runTask(deadline) {
            while ((deadline.timeRemaining() > 0 || deadline.didTimeout) && this.taskList.length && this.isActive) {
                var task = this.taskList.shift();
                task.handler(task.data);
            }

            if (this.taskList.length) {
                this.currentTaskId = _requestIdleCallback2.default.requestIdleCallback(this.runTask, { timeout: 1000 });
            } else {
                this.currentTaskId = 0;
            }
        }
    }, {
        key: 'schedule',
        value: function schedule(topics) {
            var _this = this;

            var chunks = [];
            var preparedTopics = prepareTopics(topics);

            for (var i = 0; i < topics.length; i += this.chunkSize) {
                chunks.push(preparedTopics.slice(i, i + this.chunkSize));
            }

            chunks.forEach(function (chunk) {
                _this.addTask(_this.session.subscribe, { topics: chunk });
            });
        }
    }, {
        key: 'subscribe',
        value: function subscribe(topics) {
            if (!this.session || !topics.map) {
                return;
            }

            if (topics.length <= this.chunkSize) {
                this.session.subscribe({ topics: topics });
            } else {
                this.schedule(topics);
            }
        }
    }, {
        key: 'unsubscribeAll',
        value: function unsubscribeAll() {
            this.stop();
            this.taskList = [];
            _requestIdleCallback2.default.cancelIdleCallback(this.currentTaskId);
            this.currentTaskId = 0;
            this.session.unsubscribeAll();
            this.run();
        }
    }]);

    return Subscriber;
}();

exports.default = Subscriber;


//////////////////
// WEBPACK FOOTER
// ./~/rp-prices-component/lib/js/utils/DiffusionSubscriber.js
// module id = 1795
// module chunks = 1